import React, {Component} from 'react';
import {Button, Col, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {connect} from 'react-redux';
import * as categories from '../actions/categories';
import autobind from 'autobind-decorator';

@connect(
    state => {
        return {
            categories: state.categories
        }
    },
    dispatch => {
        return {
            search: (text) => {
                dispatch(categories.searchCategory(text))
            }
        }
    }
)
export default class CategorySearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        };
    }

    @autobind
    resetSearchField() {
        this.setState({
            searchText: ''
        }, this.props.search('')
        );
        
    }

    @autobind
    handleSearchInput(e) {
        const searchText = e ? e.target.value : '';
        this.setState({
            searchText: searchText
        });
    }

    @autobind
    triggerSearch(e) {
        if(e && e.key === 'Enter')
            this.props.search(this.state.searchText);
    }


    render() {
        return (
            <Col sm={3}>
                <InputGroup>
                    <Input onChange={this.handleSearchInput} onKeyDown={this.triggerSearch} type="text" placeholder="Suche"
                           value={this.state.searchText}/>
                    <InputGroupAddon addonType={'append'}>
                        <Button onClick={this.resetSearchField}>
                            Zurücksetzen
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
            </Col>
        )
    }
}


